import React, { createContext, useContext, useEffect, useState } from "react";
import { isAuthenticated as checkAuthenticated, isAdminAuthenticated } from "../common/server";
import StorageManager from "../services/StorageManager.service";
import ApiService from "../services/ApiService";
import eventBus from "../utils/EventBus";

const AppContext = createContext();

export function useAppContext() {
    return useContext(AppContext);
}

export function AppProvider({ children }) {
    const [userAuthenticated, setUserAuthenticated] = useState(checkAuthenticated());
    const [activeUser, setActiveUser] = useState("");
    const [itemInCart, setItemInCart] = useState();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        eventBus.on("userLogin", handleUserLogin);
        eventBus.on("userLogout", handleUserLogout);
        eventBus.on("bookCourseCreated", fetchCartItem);
        eventBus.on("bookCourseDeleted", fetchCartItem);

        setActiveUser(StorageManager.getActiveUser());
        setUserAuthenticated(checkAuthenticated());
    }, []);

    useEffect(() => {
        if (userAuthenticated) {
            fetchCartItem();
        } else {
            setIsLoading(false);
        }
    }, [userAuthenticated]);

    const handleUserLogin = (data) => {
        setActiveUser(data.activeUser);
        setUserAuthenticated(true);
        eventBus.remove("userLogin");
    };

    const handleUserLogout = () => {
        setActiveUser("");
        setUserAuthenticated(false);
        setItemInCart(null);
        eventBus.remove("userLogout");
    };

    const fetchCartItem = async () => {
        try {
            const activeBasket = await ApiService.getBasketData();

            if (activeBasket !== undefined) {
                setItemInCart(activeBasket.bookCourses.length);
            }
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching cart data: ", error);
            setIsLoading(false);
        } finally {
            eventBus.remove("bookCourseCreated");
            eventBus.remove("bookCourseDeleted");
        }
    };

    const contextValue = {
        userAuthenticated,
        activeUser,
        itemInCart,
        isAdminAuthenticated: isAdminAuthenticated(),
    };

    return (
        <AppContext.Provider value={contextValue}>
            {!isLoading && children}
        </AppContext.Provider>
    );
}
